import "./Profile.css";
import React, { useState, useEffect } from "react";
import pwbannerimg from "../../Assets/Images/banner-pw.png";
import hide from "../../Assets/Images/Hide.png";
import { changePassword, updateUser, uploadProfileImage, getUser } from "../../API/User";
import * as yup from "yup";
import { useFormik } from "formik";
import { failed, success } from "@components/Common/Toastify";
import { Country } from 'country-state-city';
import envConfig from "../../environment/index";
import storage from "@utils/storage";
import PhoneInput from "react-phone-input-2";
import {
  getLatestCreditReport,
  CreditReportProfile,
} from "../../API/CreditScore";
import CreditReportSection from "./CreditReportSection";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const [btnLoading, setBtnLoading] = useState(false);
  const countries = Country.getAllCountries();
  const [profileImageUrl, setProfileImageUrl] = useState<string | null>(null);
  const imageUrl = profileImageUrl?.startsWith("blob:")
    ? profileImageUrl
    : `${envConfig.photoUrl}/public/profileImage/${profileImageUrl}`;
  const sessionUser = storage.getUser();
  const user = sessionUser?.user ?? sessionUser;
  const userId =
    sessionUser?.user?.userId ||
    user?.userId ||
    user?.uuid ||
    sessionUser?.userId ||
    sessionUser?.uuid;
  const userRole =
    sessionUser?.role ?? user?.role ?? sessionUser?.userType;
  const isBorrower = userRole === "borrower";
  const [creditReport, setCreditReport] = useState<CreditReportProfile | null>(null);
  const [creditReportLoading, setCreditReportLoading] = useState(false);
  const [imageError, setImageError] = useState<string | null>(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const profileValidationSchema = yup.object().shape({
    firstName: yup.string().matches(/^[A-Za-z\s'-]+$/, "First Name must contain only letters").required("First Name is required"),
    lastName: yup.string().matches(/^[A-Za-z\s'-]+$/, "Last Name must contain only letters").required("Last Name is required"),
    phoneNumber: yup
      .string()
      .required("Phone number is required")
      .matches(/^\+\d{6,15}$/, "Please enter valid phone number. "),
    email: yup.string().email("Invalid email").required("Email is required"),
    country: yup.string().required("Country is required"),
    state: yup.string().required("State is required"),
    city: yup.string().required("City is required"),
    region: yup.string().required("Region is required"),
    pinCode: yup
      .string()
      .required("Pin Code is required")
      .matches(/^[0-9]{3,6}$/, "Please enter a valid pin code"),
    address: yup.string().required("Address is required"),
  });


  const profileFormik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      city: "",
      email: "",
      creditScore:"",
      region: "",
      state: "",
      country: "",
      pinCode: "",
      address: "",
    },
    validationSchema: profileValidationSchema,
    // onSubmit: (values) => {
    //   setBtnLoading(true);
    //   updateUser(values)
    //     .then(() => {
    //       success("Profile updated successfully!");
    //       const userData = storage.getUser();
    //       const updatedUser = {
    //         ...userData,
    //         user: {
    //           ...userData.user,
    //           isProfileCompleted: true,
    //         },
    //       };
    //       storage.setUserType(updatedUser);
    //     })
    //     .catch((err) =>
    //       failed(err.response?.data?.message || "Profile update failed.")
    //     )
    //     .finally(() => setBtnLoading(false));
    // },
    onSubmit: (values) => {
      setBtnLoading(true);
      const { creditScore: _creditScore, ...profilePayload } = values;
      updateUser(profilePayload)
        .then(() => {
          success("Profile updated successfully!");

          // ✅ Update localStorage user object
          const currentUser = storage.getUser();
          if (currentUser) {
            const updatedUser = {
              ...currentUser,
              ...values,
              user: {
                ...currentUser.user,
                isProfileCompleted: true,
              },
            };
            storage.setUser(updatedUser);
          }
        })
        .catch((err) =>
          failed(err.response?.data?.message || "Profile update failed.")
        )
        .finally(() => setBtnLoading(false));
    },


  });

  // Toggle visibility for password field
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Toggle visibility for confirm password field
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  // PASSWORD CHANGE FORM
  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: yup.object({
      oldPassword: yup.string().required("Old Password is required"),
      newPassword: yup
        .string()
        .required("New Password is required")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/,
          "Must contain 8 characters, one uppercase, one lowercase, one number and one special character"
        ),
      confirmPassword: yup
        .string()
        .required("Confirm Password is required")
        .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
    }),
    onSubmit: (values, { resetForm }) => {
      setBtnLoading(true);
      changePassword(values)
        .then((res: any) => {
          success(res.data?.message);
          resetForm();
        })
        .catch((err) => {
          failed(err.response?.data?.message || "Password reset failed.");
        })
        .finally(() => setBtnLoading(false));
    },
  });

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];

  //   if (file) {
  //     const validTypes = ["image/png", "image/jpeg"];
  //     if (!validTypes.includes(file.type)) {
  //       setImageError("Only PNG and JPG formats are allowed.");
  //       return;
  //     }

  //     const img = new Image();
  //     const objectUrl = URL.createObjectURL(file);

  //     img.onload = () => {
  //       setImageError(null);
  //       setProfileImageUrl(objectUrl);

  //       const formData = new FormData();
  //       formData.append("profileImage", file);

  //       uploadProfileImage(formData)
  //         .then((res) => {
  //           if (res?.profileImage) {
  //             setProfileImageUrl(res.profileImage);
  //           }
  //           success("Profile image uploaded.");
  //         })
  //         .catch((err) => {
  //           failed(err.response?.data?.message || "Image upload failed.");
  //         });
  //     };

  //     img.onerror = () => {
  //       setImageError("Invalid image file.");
  //       URL.revokeObjectURL(objectUrl);
  //     };

  //     img.src = objectUrl;
  //   }
  // };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const validTypes = ["image/png", "image/jpeg"];
      if (!validTypes.includes(file.type)) {
        setImageError("Only PNG and JPG formats are allowed.");
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        setImageError(null);
        setProfileImageUrl(objectUrl);

        const formData = new FormData();
        formData.append("profileImage", file);

        uploadProfileImage(formData)
          .then((res) => {
            if (res?.profileImage) {
              setProfileImageUrl(res.profileImage);

              // ✅ Update localStorage
              const currentUser = storage.getUser();
              if (currentUser) {
                const updatedUser = {
                  ...currentUser,
                  profileImage: res.profileImage,
                };
                storage.setUser(updatedUser);
              }
            }
            window.location.reload();
            // success("Profile image uploaded.");

          })
          .catch((err) => {
            failed(err.response?.data?.message || "Image upload failed.");
          });
      };

      img.onerror = () => {
        setImageError("Invalid image file.");
        URL.revokeObjectURL(objectUrl);
      };

      img.src = objectUrl;
    }
  };


  useEffect(() => {
    if (!userId) return;

    getUser()
      .then((res: any) => {
        const data = res.data.data;
        profileFormik.setValues({
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          phoneNumber: data.phoneNumber || "",
          city: data.city || "",
          email: data.email || "",
          creditScore: data.creditScore || "",
          region: data.region || "",
          state: data.state || "",
          country: data.country || "",
          pinCode: data.pinCode || "",
          address: data.address || "",
        });
        setProfileImageUrl(data?.profileImage || null);
      })
      .catch((err) => {
        console.error("Failed to fetch user data", err);
      });

    if (!isBorrower) return;

    setCreditReportLoading(true);
    getLatestCreditReport(userId)
      .then((res) => {
        const { report, creditScore } = res.data;
        setCreditReport(report);
        if (creditScore !== null && creditScore !== undefined) {
          profileFormik.setFieldValue("creditScore", creditScore);
        } else if (report?.creditScore !== null && report?.creditScore !== undefined) {
          profileFormik.setFieldValue("creditScore", report.creditScore);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch credit report", err);
      })
      .finally(() => setCreditReportLoading(false));
  }, [userId, isBorrower]);

  useEffect(() => {
  }, [activeTab]);

  return (
    <div className="content dashboard">
      <div className="content-wrapper">
        {/* <div className="buttons tabs-btns d-flex align-items-center gap-3">
          <button
            className={`tab-button d-flex gap-2 align-items-center button-outline profile-tab ${activeTab === "profile" ? "active" : ""
              }`}
            onClick={() => setActiveTab("profile")}
          >
            <div className="profile-img">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_783_523)">
                  <path
                    opacity="0.8"
                    d="M12 0.000976562C5.37328 0.000976562 0 5.3732 0 12.0004C0 18.6277 5.37275 23.9999 12 23.9999C18.6278 23.9999 24 18.6277 24 12.0004C24 5.3732 18.6278 0.000976562 12 0.000976562ZM12 3.58896C13.0527 3.58889 14.0622 4.00699 14.8066 4.75129C15.551 5.49558 15.9693 6.50511 15.9693 7.55777C15.9694 8.61043 15.5513 9.62001 14.807 10.3644C14.0627 11.1088 13.0532 11.527 12.0005 11.5271C10.9479 11.5272 9.93828 11.1091 9.19389 10.3648C8.44949 9.62049 8.03126 8.61096 8.03119 7.5583C8.03112 6.50563 8.44922 5.49606 9.19352 4.75166C9.93781 4.00726 10.9473 3.58903 12 3.58896ZM11.9974 20.8626C9.89458 20.865 7.86035 20.1148 6.2625 18.7479C6.07655 18.5892 5.9272 18.3921 5.82474 18.1702C5.72228 17.9482 5.66914 17.7067 5.66898 17.4623C5.66898 15.2395 7.46798 13.4605 9.69129 13.4605H14.3098C16.5336 13.4605 18.3257 15.2395 18.3257 17.4623C18.3259 17.7066 18.2729 17.9481 18.1706 18.17C18.0682 18.3919 17.9188 18.5889 17.7328 18.7474C16.135 20.1149 14.1004 20.8652 11.9974 20.8626Z"
                    fill="#2C3E50"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_783_523">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>{" "}
            <div>Profile Settings</div>
          </button>

          <button
            className={`tab-button d-flex gap-2 align-items-center button-outline changepw-tab ${activeTab === "password" ? "active" : ""
              }`}
            onClick={() => setActiveTab("password")}
          >
            <div className="profile-img">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.8" clipPath="url(#clip0_341_8700)">
                  <path
                    d="M11.9998 9.53271C11.7317 9.53409 11.475 9.64121 11.2854 9.83079C11.0958 10.0204 10.9887 10.2771 10.9873 10.5452V10.9952H13.0123V10.5452C13.0109 10.2771 12.9038 10.0204 12.7142 9.83079C12.5246 9.64121 12.2679 9.53409 11.9998 9.53271Z"
                    fill="#2C3E50"
                  />
                  <path
                    d="M12 0.75C9.77497 0.75 7.59989 1.4098 5.74984 2.64597C3.89979 3.88213 2.45785 5.63914 1.60636 7.69481C0.754875 9.75048 0.532087 12.0125 0.966171 14.1948C1.40025 16.3771 2.47171 18.3816 4.04505 19.955C5.61839 21.5283 7.62295 22.5998 9.80524 23.0338C11.9875 23.4679 14.2495 23.2451 16.3052 22.3936C18.3609 21.5422 20.1179 20.1002 21.354 18.2502C22.5902 16.4001 23.25 14.225 23.25 12C23.249 9.01662 22.0634 6.15571 19.9539 4.04615C17.8443 1.93658 14.9834 0.750994 12 0.75ZM18.3 16.41C17.865 16.4325 17.7975 15.8325 17.67 15.54C14.1075 21.225 5.31001 18.75 5.25 12C5.25 11.9409 5.26164 11.8824 5.28426 11.8278C5.30687 11.7732 5.34002 11.7236 5.38181 11.6818C5.42359 11.64 5.4732 11.6069 5.5278 11.5843C5.58239 11.5616 5.64091 11.55 5.70001 11.55C5.7591 11.55 5.81762 11.5616 5.87221 11.5843C5.92681 11.6069 5.97642 11.64 6.0182 11.6818C6.05999 11.7236 6.09314 11.7732 6.11575 11.8278C6.13837 11.8824 6.15 11.9409 6.15 12C6.15073 13.2712 6.56792 14.5071 7.33775 15.5186C8.10757 16.5302 9.18763 17.2616 10.4126 17.601C11.6376 17.9405 12.9401 17.8692 14.1208 17.3981C15.3014 16.927 16.2952 16.082 16.95 14.9925L16.11 15.1275C16.0509 15.1393 15.99 15.139 15.931 15.1267C15.872 15.1144 15.8161 15.0903 15.7666 15.0559C15.7171 15.0215 15.675 14.9774 15.6429 14.9264C15.6108 14.8754 15.5893 14.8184 15.5798 14.7589C15.5702 14.6994 15.5727 14.6386 15.5871 14.58C15.6016 14.5215 15.6277 14.4665 15.6639 14.4183C15.7001 14.3701 15.7456 14.3297 15.7978 14.2995C15.85 14.2693 15.9077 14.2499 15.9675 14.2425L17.6775 13.965C17.7808 13.9519 17.8855 13.9735 17.9751 14.0264C18.0647 14.0794 18.1342 14.1607 18.1725 14.2575L18.72 15.81C18.7442 15.8775 18.7519 15.9499 18.7424 16.021C18.7329 16.0921 18.7064 16.1599 18.6653 16.2187C18.6241 16.2775 18.5695 16.3255 18.5059 16.3588C18.4424 16.3921 18.3718 16.4097 18.3 16.41ZM14.505 10.995C14.6242 10.9954 14.7385 11.0429 14.8228 11.1272C14.9071 11.2115 14.9546 11.3258 14.955 11.445V14.9175C14.9546 15.0367 14.9071 15.151 14.8228 15.2353C14.7385 15.3196 14.6242 15.3671 14.505 15.3675H9.495C9.37578 15.3671 9.26155 15.3196 9.17724 15.2353C9.09294 15.151 9.0454 15.0367 9.04501 14.9175V11.445C9.0454 11.3258 9.09294 11.2115 9.17724 11.1272C9.26155 11.0429 9.37578 10.9954 9.495 10.995H10.0875V10.545C10.0875 10.0378 10.289 9.55132 10.6477 9.19266C11.0063 8.83399 11.4928 8.6325 12 8.6325C12.5072 8.6325 12.9937 8.83399 13.3523 9.19266C13.711 9.55132 13.9125 10.0378 13.9125 10.545V10.995H14.505ZM18.3 12.45C18.1808 12.4496 18.0666 12.4021 17.9822 12.3178C17.8979 12.2335 17.8504 12.1192 17.85 12C17.8493 10.7288 17.4321 9.49292 16.6623 8.48138C15.8924 7.46984 14.8124 6.73838 13.5874 6.39895C12.3624 6.05953 11.0599 6.13082 9.87924 6.60192C8.6986 7.07302 7.70483 7.91798 7.05 9.0075L7.89001 8.8725C7.94913 8.86075 8.01001 8.86103 8.06902 8.87334C8.12803 8.88564 8.18396 8.90972 8.23345 8.94412C8.28295 8.97853 8.325 9.02256 8.3571 9.07358C8.38919 9.12461 8.41067 9.18158 8.42026 9.24109C8.42984 9.30061 8.42733 9.36144 8.41287 9.41996C8.39841 9.47848 8.37231 9.53349 8.33611 9.58169C8.29992 9.62989 8.25438 9.67031 8.20221 9.70051C8.15005 9.73072 8.09233 9.7501 8.03251 9.7575L6.3225 10.035C6.21894 10.0506 6.11316 10.0301 6.02299 9.97678C5.93282 9.9235 5.86378 9.84076 5.82751 9.7425L5.27251 8.19C5.23272 8.07662 5.23961 7.95208 5.29165 7.84378C5.34369 7.73548 5.43663 7.65228 5.55 7.6125C5.66338 7.57272 5.78792 7.5796 5.89623 7.63165C6.00453 7.68369 6.08772 7.77662 6.12751 7.89L6.33 8.46C9.8925 2.775 18.69 5.25 18.75 12C18.7496 12.1192 18.7021 12.2335 18.6178 12.3178C18.5335 12.4021 18.4192 12.4496 18.3 12.45Z"
                    fill="#2C3E50"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_341_8700">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>{" "}
            <div>Change Password</div>
          </button>
        </div> */}
        {/* {activeTab === "profile" && ( */}

        {/* <h1 className="main-title-text">My Profile</h1> */}
        <div className="outer-box-wrapper">

          <div className="col-lg-8 mb-4">
            <h4 className="info-title-text">Personal Info</h4>
            <div className="profile-upper-block d-flex align-items-center mt-3 ms-5 justify-content-between">
              <div className="profile-image image-box">
                {profileImageUrl ? (
                  <img
                    // src={imageUrl}
                    src={imageUrl}
                    alt="Profile"
                    className="rounded-full object-cover"
                  />
                ) : (
                  <div className="name-initials">
                    <span className="text-capitalize"> {user?.firstName?.[0] || "A"}</span>
                    <span className="text-capitalize"> {user?.lastName?.[0] || "L"}</span>
                  </div>
                )}
                <label htmlFor="file-upload" className="edit-icon">
                  &#9998;
                </label>
                <input
                  id="file-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>
              {imageError && (
                <div className="text-danger mt-2" style={{ fontSize: "0.875rem" }}>
                  {imageError}
                </div>
              )}
              <div className="edit-profile">
              </div>
            </div>

            {/* Profile Form */}
            <form className="onboarding-form profile change-password-form ps-0" onSubmit={profileFormik.handleSubmit}>
              <div className="row g-3 mb-4">
                <div className="col-md-6">
                  <label className="form-label">First Name <span>*</span></label>
                  <input
                    type="text"
                    name="firstName"
                    className="form-control"
                    value={profileFormik.values.firstName}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {profileFormik.touched.firstName && profileFormik.errors.firstName && (
                    <div className="text-danger">{profileFormik.errors.firstName}</div>
                  )}
                </div>
                <div className="col-md-6">
                  <label className="form-label">Last Name <span>*</span></label>
                  <input
                    type="text"
                    name="lastName"
                    className="form-control"
                    value={profileFormik.values.lastName}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {profileFormik.touched.lastName && profileFormik.errors.lastName && (
                    <div className="text-danger">{profileFormik.errors.lastName}</div>
                  )}
                </div>
                <div className="col-md-4 phone-number-label ">
                  <label className="form-label">Phone Number</label>
                  <PhoneInput
                    country="gb" // default country code
                    placeholder="Phone Number"
                    value={profileFormik.values.phoneNumber}
                    onChange={(value) => {
                      // Normalize value with '+' prefix if missing
                      const normalized = value.startsWith('+') ? value : `+${value}`;
                      profileFormik.setFieldValue('phoneNumber', normalized);
                    }}
                    onBlur={() => profileFormik.setFieldTouched('phoneNumber', true)}
                    inputProps={{
                      name: 'phoneNumber',
                      required: true,
                      autoFocus: false,
                    }}
                    inputClass={profileFormik.touched.phoneNumber && profileFormik.errors.phoneNumber ? "input-error" : ""}
                  />
                  {profileFormik.touched.phoneNumber && profileFormik.errors.phoneNumber && (
                    <div className="error-message">{profileFormik.errors.phoneNumber as string}</div>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">Email <span>*</span></label>
                  <input
                    type="email"
                    name="email"
                    disabled
                    className="form-control"
                    value={profileFormik.values.email}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {profileFormik.touched.email && profileFormik.errors.email && (
                    <div className="text-danger">{profileFormik.errors.email}</div>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label">Credit Score <span>*</span></label>
                  <input
                    type="text"
                    name="creditScore"
                    disabled
                    className="form-control"
                    value={profileFormik.values.creditScore}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {/* {profileFormik.touched.email && profileFormik.errors.email && (
                    <div className="text-danger">{profileFormik.errors.email}</div>
                  )} */}
                </div>
              </div>

              <div className="row g-3 mb-4">

                <div className="col-md-6">
                  <label className="form-label">
                    Country <span>*</span>
                  </label>
                  <select
                    name="country"
                    className="form-control"
                    value={profileFormik.values.country}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.isoCode} value={country.isoCode}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                  {profileFormik.touched.country && profileFormik.errors.country && (
                    <div className="text-danger">{profileFormik.errors.country}</div>
                  )}

                </div>


                <div className="col-md-6">
                  <label className="form-label">State <span>*</span></label>
                  <input
                    type="text"
                    name="state"
                    className="form-control"
                    value={profileFormik.values.state}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {profileFormik.touched.state && profileFormik.errors.state && (
                    <div className="text-danger">{profileFormik.errors.state}</div>
                  )}
                </div>


              </div>

              <div className="row g-3 mb-4">

                <div className="col-md-4">
                  <label className="form-label">City <span>*</span></label>
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    value={profileFormik.values.city}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {profileFormik.touched.city && profileFormik.errors.city && (
                    <div className="text-danger">{profileFormik.errors.city}</div>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label">Region <span>*</span></label>
                  <input
                    type="text"
                    name="region"
                    className="form-control"
                    value={profileFormik.values.region}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {profileFormik.touched.region && profileFormik.errors.region && (
                    <div className="text-danger">{profileFormik.errors.region}</div>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label">Pin Code <span>*</span></label>
                  <input
                    type="text"
                    name="pinCode"
                    className="form-control"
                    value={profileFormik.values.pinCode}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {profileFormik.touched.pinCode && profileFormik.errors.pinCode && (
                    <div className="text-danger">{profileFormik.errors.pinCode}</div>
                  )}
                </div>
              </div>

              <div className="row g-3 mb-4">
                <div className="col-12">
                  <label className="form-label">Address <span>*</span></label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    value={profileFormik.values.address}
                    onChange={profileFormik.handleChange}
                    onBlur={profileFormik.handleBlur}
                  />
                  {profileFormik.touched.address && profileFormik.errors.address && (
                    <div className="text-danger">{profileFormik.errors.address}</div>
                  )}
                </div>
              </div>

              <div className="mt-4 d-flex gap-3 save-cancel-btnblock">
                <button type="submit" className="button-save save-btn" disabled={btnLoading}>
                  {btnLoading ? "Saving..." : "Save"}
                </button>
                <button type="reset" className="button-outline cancel-btn">
                  Cancel
                </button>
              </div>
            </form>

            {isBorrower && (
              <CreditReportSection
                report={creditReport}
                loading={creditReportLoading}
              />
            )}
          </div>


          <div className="pt-2">
            <div className="col-lg-8 p-0 pw-change pw-change-wrapper">
              {/* <h2 className="secure-pw">Secure Your Lending Journey</h2> */}
              <h2 className="secure-pw">Change Password</h2>
              {/* <p>
                To enhance your security, please create a strong password that
                contains a combination of letters, numbers, and symbols.
              </p> */}
              <form className="onboarding-form profile p-3" onSubmit={formik.handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">
                    Current Password <span>*</span>
                  </label>
                  <div className="pw-input-block position-relative">
                    <input
                      type={passwordVisible ? "text" : "password"} // Toggle type between text and password
                      className="form-control"
                      name="oldPassword"
                      placeholder="Enter current password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.oldPassword}
                    />
                    <div
                      className="eye-icon"
                      onClick={togglePasswordVisibility} // Toggle password visibility on click
                    >
                      <img src={hide} alt="eye icon" className="img-fluid" />
                    </div>
                  </div>
                  {formik.touched.oldPassword && formik.errors.oldPassword && (
                    <div className="text-danger">{formik.errors.oldPassword}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Password <span>*</span>
                  </label>
                  <div className="pw-input-block position-relative">
                    <input
                      type={passwordVisible ? "text" : "password"} // Toggle type between text and password
                      className="form-control"
                      name="newPassword"
                      placeholder="Enter new password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.newPassword}
                    />
                    <div
                      className="eye-icon"
                      onClick={togglePasswordVisibility} // Toggle password visibility on click
                    >
                      <img src={hide} alt="eye icon" className="img-fluid" />
                    </div>
                  </div>
                  {formik.touched.newPassword && formik.errors.newPassword && (
                    <div className="text-danger">{formik.errors.newPassword}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Confirm Password <span>*</span>
                  </label>
                  <div className="pw-input-block position-relative">
                    <input
                      type={confirmPasswordVisible ? "text" : "password"} // Toggle type between text and password
                      className="form-control"
                      name="confirmPassword"
                      placeholder="Confirm new password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.confirmPassword}
                    />
                    <div
                      className="eye-icon"
                      onClick={toggleConfirmPasswordVisibility} // Toggle confirm password visibility on click
                    >
                      <img src={hide} alt="eye icon" className="img-fluid" />
                    </div>
                  </div>
                  {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                    <div className="text-danger">{formik.errors.confirmPassword}</div>
                  )}
                </div>

                <div className="mt-4 ">
                  <button
                    type="submit"
                    className="button-save save-btn w-50"
                    disabled={btnLoading}
                  >
                    {btnLoading ? "Updating..." : "Change Password"}
                  </button>
                </div>
              </form>
            </div>
            {/* <div className="col-lg-6 changepw-banner d-flex align-items-center justify-content-center">
              <img src={pwbannerimg} alt="" className="img-fluid" />
            </div> */}
          </div>

        </div>
        {/* )} */}

        {/* {activeTab === "password" && ( */}

        {/* )} */}
      </div>
    </div>
  );
};

export default Profile;
